import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import Button from '../Button';
import Plus from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Check from '@wix/da-ds/pkg/Icons/Check';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { useWatchButton } from '../../WatchButton/useWatchButton';
import s from './ProfileOwnerWatchButton.scss';
import sV2 from './ProfileOwnerWatchButtonV2.scss';
const ProfileOwnerWatchButton = ({ disabled , height ='medium' , className , view , disableClickHandler , user , initialData , onClick: onClickProp , useV2Styles =true , isFakeButton , fullWidth , renderCustomText , onToggleWatchSuccess , allowUnsubscribe , isWatchingBack =false , hidePlusIcon =false  })=>{
    var _user_isWatching;
    const { text , isWatching , isSubscribed , isLoading , biData , onClick  } = useWatchButton(user, (_user_isWatching = user.isWatching) !== null && _user_isWatching !== void 0 ? _user_isWatching : initialData === null || initialData === void 0 ? void 0 : initialData.isWatching, isWatchingBack, disabled, onToggleWatchSuccess, allowUnsubscribe);
    const [isNewWatching, setIsNewWatching] = useState(false);
    const defaultWatchingState = !isLoading && isWatching;
    const loadingWatchingState = isLoading && !isWatching;
    const loadingUnwatchingState = isLoading && isWatching;
    const handleClick = useCallback((e)=>{
        if (disableClickHandler) {
            return;
        }
        setIsNewWatching(!isWatching);
        onClick();
        onClickProp && onClickProp(e);
    }, [
        disableClickHandler,
        isWatching,
        onClick,
        onClickProp
    ]);
    const handleMouseLeave = useCallback((e)=>{
        // when you click on button's child elements,
        // the mouseleave event triggers
        if (e.currentTarget !== e.target) {
            return;
        }
        setIsNewWatching(false);
    }, []);
    const styles = useV2Styles ? sV2 : s;
    const shouldUseUnwatchStyling = defaultWatchingState && !isNewWatching && !isSubscribed;
    const shouldUseLoadingUnwatchingStyling = loadingUnwatchingState && !isSubscribed;
    return /*#__PURE__*/ React.createElement(Button, {
        view: view ? view : 'b1',
        biData: biData,
        height: height,
        className: classnames(styles['root'], shouldUseUnwatchStyling && styles['watch-btn-unwatch'], defaultWatchingState && styles['watch-btn-watching'], shouldUseLoadingUnwatchingStyling && styles['watch-btn-loading-unwatch'], loadingWatchingState && styles['watch-btn-loading'], className),
        onClick: handleClick,
        onMouseLeave: handleMouseLeave,
        disabled: disabled,
        dataHook: BiDataHook.USER_WATCH_BUTTON,
        isFakeButton: isFakeButton,
        fullWidth: fullWidth
    }, // We rotate the plus icon to show a close icon, so we still want to show it in those cases even if `hidePlusIcon` is true
    (!hidePlusIcon || shouldUseUnwatchStyling || shouldUseLoadingUnwatchingStyling) && /*#__PURE__*/ React.createElement(Plus, {
        customSizable: true,
        disableDefaultColors: true,
        className: styles['plus-icon'],
        size: IconSize.SMALL
    }), isWatching && !isLoading && /*#__PURE__*/ React.createElement(Check, {
        customSizable: true,
        disableDefaultColors: true,
        className: styles['check-icon'],
        size: IconSize.SMALL
    }), /*#__PURE__*/ React.createElement("span", {
        className: classnames((defaultWatchingState || loadingWatchingState) && styles['watch-btn-text'])
    }, renderCustomText ? renderCustomText(isWatching) : text));
};
ProfileOwnerWatchButton.displayName = 'ProfileOwnerWatchButton';
export default ProfileOwnerWatchButton;
